import React from "react";

import clsx from "clsx";

import NoDataIcon from "@assets/nodata-icon.svg";
import { GenericTooltip } from "@components/tooltip-container";
import { useFeatureFlags } from "@hooks/http";
import { IconContainer } from "@pages/objects/utils";

const Notification = ({
  text,
  icon,
  className,
  placement = "topRight",
  tooltip,
}: {
  text: string;
  icon: React.ReactNode;
  className?: string;
  placement?: "topLeft" | "topRight";
  tooltip: React.ReactNode;
}) => {
  const { hasFeatureFlag } = useFeatureFlags();

  const right = "right-1";
  const left = "left-1";

  return (
    <div
      className={clsx(
        "absolute flex text-sm items-center font-semibold rounded-lg px-2 top-[2.3rem]",
        className,
        placement === "topRight" ? right : left,
      )}
    >
      {icon}
      <span>{text}</span>
      <GenericTooltip
        className="mb-5 self-center"
        content={<div className="max-w-[25rem]">{tooltip}</div>}
      />
    </div>
  );
};

export const NoDataNotification = ({
  placement,
  className,
}: {
  placement?: "topLeft" | "topRight";
  className?: string;
}) => {
  return (
    <Notification
      text="Not enough data to show"
      icon={
        <IconContainer sizeInEM={1.5} style={{ marginRight: "0.25em" }}>
          <img className="cursor-pointer" alt="no-data icon" src={NoDataIcon} />
        </IconContainer>
      }
      className={clsx("bg-[#F5F5F5] text-[#717680]", className)}
      placement={placement}
      tooltip={
        "Consistent spending and attributed revenue are required " +
        "to calculate your 1-day benchmarks for this platform."
      }
    />
  );
};
